<template>
  <v-container fluid>
    <v-card class="mx-auto" flat color="Neutral">
      <v-card-text >
        <v-img contain src="../assets/images/TRINITYBoardLanding.png"></v-img>
      </v-card-text>
      <v-row>
        <v-col align="left" justify="center" class="pa-8" cols="6">
          <h1 style="font-family: Meiryo UI">
            Why
            <span
              style="font-family: Meiryo UI; font-weight: 700; color: #324154"
              >TRINITY</span
            ><span style="color: #0167ab">BOARD</span>?
          </h1>
          <p>
            Increased regulatory scrutiny has led to larger boards with more
            frequent meeting schedules and document review. This has fueled the
            need for a solution like TRINITY BOARD that go beyond board meeting
            management to assist you with governance resources and to help in
            the decision-making process. TRINITY BOARD provides a highly
            collaborative, secure tool for board of directors with insights and
            analytics to securely access board materials, track company
            performance and gather the vital information around competitive news
            & press releases to achieve good governance.
          </p>
          <!-- <v-avatar size="100" icon>
         <v-img src="../assets/images/AvantBoardLogo.png" alt="AVANTBoard"></v-img>
      </v-avatar>
      <h1 style="font-family: Meiryo UI; font-weight: 700; font-size:50px; color: #324154"
        >AVANT<span style="color: #0167AB">Board</span></h1>
      <v-card-subtitle class="pb-0">
        <h1 style="color: #0167AB;font-family: Meriyo UI; font-size:25px;"><i>{{$t('avantboard-tag-line')}}</i></h1>
      </v-card-subtitle>
         <v-avatar size="50" tile>       
      </v-avatar> -->
        </v-col>
        <v-col align="left" justify="center" class="pa-8" cols="6">
          <h1 style="font-family: Meiryo UI">
            What is
            <span
              style="font-family: Meiryo UI; font-weight: 700; color: #324154"
              >TRINITY</span
            ><span style="color: #0167ab">BOARD</span>?
          </h1>
          <p>
            TRINITY BOARD is a Board Management Portal with governance tools and
            helps distribute board meeting materials across the organization.
            You can add, edit, and remove documents via a centralized document
            storage. All Documents or other assets stored on the platform are
            viewable only by those given access by the software administrator.
          </p>

          <!-- <v-avatar size="100" icon>
         <v-img src="../assets/images/AvantBoardLogo.png" alt="AVANTBoard"></v-img>
      </v-avatar>
      <h1 style="font-family: Meiryo UI; font-weight: 700; font-size:50px; color: #324154"
        >AVANT<span style="color: #0167AB">Board</span></h1>
      <v-card-subtitle class="pb-0">
        <h1 style="color: #0167AB;font-family: Meriyo UI; font-size:25px;"><i>{{$t('avantboard-tag-line')}}</i></h1>
      </v-card-subtitle>
         <v-avatar size="50" tile>       
      </v-avatar> -->
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>


<style scoped>
::v-deep .container--fluid {
  padding: 0px !important;
}
</style>
<script>
export default {
  name: "LandingView",
  data() {
    return {
      MicrosoftPng: "../assets/images/Microsoft.png",
    };
  },
  methods: {
    login() {
      this.$emit("login");
    },
  },
};
</script>